export const error = {
    default: "Unable to complete the desired action!",
    invalid: "This field is invalid!",
    required: "This field is required!",
    not_equal: "The fields must be equal!",
    bad_requrest: "Error loading data {name}",
    min: "Minimum of {min} characters!",
    unauthorized: "Unauthorized",
};
